import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-eye-open-green",
  "use": "icon-eye-open-green-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eye-open-green\">\n<path d=\"M2.87553 5.25C1.81991 6.125 1.16699 7 1.16699 7C1.16699 7 3.77866 10.5 7.00033 10.5C7.39988 10.5 7.79004 10.4462 8.16699 10.3519M5.84293 3.64583C6.21703 3.55297 6.60407 3.5 7.00033 3.5C10.222 3.5 12.8337 7 12.8337 7C12.8337 7 12.1807 7.875 11.1251 8.75\" stroke=\"#00B882\" stroke-width=\"1.16667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"7\" cy=\"7\" r=\"1.5\" stroke=\"#00B882\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/eye-open-green.svg
// module id = cQjs
// module chunks = 1